import { createRouter, createWebHistory } from 'vue-router'; 
import i18n from './i18n';
 

import NoahMain from './components/NoahMain.vue';
import ProductMain from './components/products/ProductMain.vue';




 
import ShowRoom from './components/ShowRoom.vue';
import SurveyHub from './components/anket/SurveyHub.vue';
import UcretsizEgitim from './components/education/UcretsizEgitim.vue';
import EducationDetail from './components/education/EducationDetail.vue';

import KendiniTestEt from './components/education/EducationMain.vue';
import MasterClassEgitim from './components/MasterClassEgitim.vue';
import NoahMasterWorld from './components/NoahMasterWorld.vue';

import UluslararasiSertifikalar from './components/UluslararasiSertifikalar.vue';

import Portal from './components/application/AppMain.vue';
import AccountingMain from './components/muhasebe/AccountingMain.vue';
import RandevuTakip from './components/randevu/RandevuTakip.vue'; 
import NoahDuyurular from './components/NoahDuyurular.vue'; 
import NoahHakkinda from './components/pages/NoahHakkinda.vue';
import VeriGizliligi from './components/pages/VeriGizliligi.vue'; 
import KullanimKosullari from './components/pages/KullanimKosullari.vue'; 
import CerezPolitikasi from './components/pages/CerezPolitikasi.vue'; 
import UserAgreements from './components/pages/UserAgreements.vue'; 
import BrandKit from './components/contact/BrandKit.vue'; 
import SsS from './components/FaqAccordion.vue'; 

import NoahChat from './components/community/NoahChat.vue'; 

import NoahAi from './components/noahai/NoahAiHome.vue';  

import SoruCevap from './components/forum/NoahForum.vue';  
import SoruCevapArsiv from './components/forum/UnsolvedQuestions.vue'; 

import MyNotes from './components/mynotes/MyNotesMain.vue'; 

import HowToUseGallery from './components/HowToUseGallery.vue'; 
import UserProfile from './components/profile/UserProfile.vue'; 
import HesapSeviyeleri from './components/HesapSeviyeleri.vue'; 

import UserLogin from './components/UserLogin.vue'; 
import UserRegister from './components/UserRegister.vue'; 


import AuthContacts from './components/contact/AuthContacts.vue';  
import KasOlcum from './components/kasolcum/KasOlcum.vue';
import ShopWebsitesByLanguage from './components/ShopWebsitesByLanguage.vue';
import FitMain from './components/noahfit/FitMain.vue';
import ResetPassword from './components/ResetPassword.vue';
import ForgotPassword from './components/ForgotPassword.vue';
import CatalougeView from './components/katalog/CatalougeView.vue';


const routes = [ 
  { path: '/', component: NoahMain, meta: { titleKey: 'router.titles.home' } },
  { path: '/urunler', component: ProductMain, meta: { titleKey: 'router.titles.products' } },   
  { path: '/katalog', component: CatalougeView, meta: { titleKey: 'router.titles.catalog' } },  
  { path: '/shopwebsiteleri', component: ShopWebsitesByLanguage, meta: { titleKey: 'router.titles.shop_websites' } },

  { path: '/ucretsizegitim', component: UcretsizEgitim, meta: { titleKey: 'router.titles.free_education' } },
  {
    path: '/egitimler/:educationId/:languageId',
    name: 'EducationDetail',
    component: EducationDetail,
    props: true,
    meta: { titleKey: 'router.titles.education_detail' },
  },  
  { path: '/login', component: UserLogin, meta: { titleKey: 'router.titles.login' } },
  { path: '/kayitol', component: UserRegister, meta: { titleKey: 'router.titles.register' } },
  { path: '/hesabim', component: UserProfile, meta: { titleKey: 'router.titles.profile' } },
  { path: '/hesabim/:componentname?', component: UserProfile, meta: { titleKey: 'router.titles.profile' } },


  { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword, meta: { titleKey: 'router.titles.forgot_password' } },
  { path: '/reset-password', name: 'ResetPassword', component: ResetPassword, meta: { titleKey: 'router.titles.reset_password' } },
  


  { path: '/kendinitestet', component: KendiniTestEt, meta: { titleKey: 'router.titles.test_yourself' } }, 
  { path: '/masterclassegitim', component: MasterClassEgitim, meta: { titleKey: 'router.titles.master_class' } },
  { path: '/noahmasterworld', component: NoahMasterWorld, meta: { titleKey: 'router.titles.master_world' } },
  { path: '/sertifikalar', component: UluslararasiSertifikalar, meta: { titleKey: 'router.titles.certificates' } },
  { path: '/portal', component: Portal, meta: { titleKey: 'router.titles.portal' } },


  { path: '/portal/muhasebe', component: AccountingMain, meta: { titleKey: 'router.titles.accounting' } },
  { 
    path: '/portal/muhasebe/:id', 
    name: 'WalletDetail', 
    component: AccountingMain, 
    props: true,
    meta: { titleKey: 'router.titles.wallet_detail' } 
  },

  { path: '/portal/randevu-takip', component: RandevuTakip, meta: { titleKey: 'router.titles.appointments' } },

  { path: '/portal/kasolcum', component: KasOlcum, meta: { titleKey: 'router.titles.kasolcum' } },

  { path: '/noah-chat', component: NoahChat, meta: { titleKey: 'router.titles.noah_chat' } },
  { path: '/noahai', component: NoahAi, meta: { titleKey: 'router.titles.noah_ai' } },
  { path: '/noahfit', component: FitMain, meta: { titleKey: 'router.titles.noah_fit' } },


  { path: '/iletisim', component: AuthContacts, meta: { titleKey: 'router.titles.contact' } }, 
  { path: '/showroom', component: ShowRoom, meta: { titleKey: 'router.titles.showroom' } }, 
  { path: '/sss', component: SsS, meta: { titleKey: 'router.titles.faq' } },
  { path: '/anketler', component: SurveyHub, meta: { titleKey: 'router.titles.surveys' } },
  { path: '/hakkimizda', component: NoahHakkinda, meta: { titleKey: 'router.titles.about' } },
  { path: '/veri-gizliligi', component: VeriGizliligi, meta: { titleKey: 'router.titles.privacy' } },
  { path: '/kullanim-kosullari', component: KullanimKosullari, meta: { titleKey: 'router.titles.terms' } },
  { path: '/cerez-politikasi', component: CerezPolitikasi, meta: { titleKey: 'router.titles.cookies' } },
  { path: '/sozlesmeler', component: UserAgreements, meta: { titleKey: 'router.titles.agreements' } },
  { path: '/marka-materyal', component: BrandKit, meta: { titleKey: 'router.titles.brand_kit' } },
   
  { path: '/notlarim', component: MyNotes, meta: { titleKey: 'router.titles.my_notes' } },

  { path: '/kullanim-kilavuzu', component: HowToUseGallery, meta: { titleKey: 'router.titles.user_guide' } },

  { path: '/soru-cevap', component: SoruCevap, meta: { titleKey: 'router.titles.qa' } },
  { path: '/soru-cevap/arsiv', component: SoruCevapArsiv, meta: { titleKey: 'router.titles.qa_archive' } },
  { path: '/etkinlikler', component: NoahDuyurular, meta: { titleKey: 'router.titles.announcements' } },
  { path: '/hesap-seviyeleri', component: HesapSeviyeleri, meta: { titleKey: 'router.titles.account_levels' } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) { 
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});
 
router.beforeEach((to, from, next) => {
  const defaultTitle = i18n.global.t('router.titles.default');
  const titleKey = to.meta && to.meta.titleKey;
  document.title = titleKey ? i18n.global.t(titleKey) : defaultTitle;
  next();
});

export default router;
